import type { StateCreator } from "zustand";
import {
  type SavedViewStateSlice,
  createEditSavedViewInitialState,
  deleteSavedViewInitialState,
} from "./saved-views-management.slice";

type SavedViewActions = Pick<
  SavedViewStateSlice,
  | "setIsCreateOrEditSavedViewModalOpen"
  | "setIsDeleteSavedViewModalOpen"
  | "setSelectedSavedViewId"
  | "setSavedViewName"
  | "onEditSavedView"
  | "resetCreateEditSavedView"
  | "resetDeleteSavedView"
>;

export const createSavedViewActions: StateCreator<
  SavedViewStateSlice,
  [["zustand/devtools", never]],
  [],
  SavedViewActions
> = (set) => ({
  setIsCreateOrEditSavedViewModalOpen: (isOpen: boolean) =>
    set(
      { isCreateOrEditSavedViewModalOpen: isOpen },
      false,
      "[User] SavedView: Toggle create or edit saved view modal open",
    ),
  setIsDeleteSavedViewModalOpen: (isOpen: boolean) =>
    set(
      { isDeleteSavedViewModalOpen: isOpen },
      false,
      "[User] SavedView: Toggle delete saved view modal open",
    ),
  setSelectedSavedViewId: (id: string | null) =>
    set(
      { selectedSavedViewId: id },
      false,
      "[User] SavedView: Set selected saved view id",
    ),
  setSavedViewName: (name: string) =>
    set({ name }, false, "[User] SavedView: Set saved view name"),
  onEditSavedView: ({ savedViewId, name }) =>
    set(
      {
        selectedSavedViewId: savedViewId,
        name,
      },
      false,
      "[User] SavedView: Set edit saved view data",
    ),
  resetCreateEditSavedView: () =>
    set(
      { ...createEditSavedViewInitialState },
      false,
      "Reset create/edit saved view state",
    ),
  resetDeleteSavedView: () =>
    set(
      {
        ...deleteSavedViewInitialState,
        selectedSavedViewId: null,
        name: "",
      },
      false,
      "Reset delete saved view state",
    ),
});
